import { tokens } from "../theme";

export const mockDataTeam = [
  {
    id: 1,
    name: "Walter White",
    email: "walterwhite@gmail.com",
    age: 50,
    phone: "(665)121-5454",
    access: "admin",
  },
  {
    id: 2,
    name: "Jesse Pinkman",
    email: "jessepinkman@gmail.com",
    age: 25,
    phone: "(421)314-2288",
    access: "manager",
  },
  {
    id: 3,
    name: "Skyler White",
    email: "skylerwhite@gmail.com",
    age: 45,
    phone: "(422)982-6739",
    access: "user",
  },
  {
    id: 4,
    name: "Saul Goodman",
    email: "saulgoodman@gmail.com",
    age: 41,
    phone: "(921)425-6742",
    access: "admin",
  },
  {
    id: 5,
    name: "Hank Schrader",
    email: "hankschrader@gmail.com",
    age: 43,
    phone: "(421)445-1189",
    access: "user",
  },
  {
    id: 6,
    name: "Gus Fring",
    email: "gusfring@gmail.com",
    age: 49,
    phone: "(232)545-6483",
    access: "manager",
  },
  {
    id: 7,
    name: "Marie Schrader",
    email: "marieschrader@gmail.com",
    age: 38,
    phone: "(543)124-0123",
    access: "user",
  },
  {
    id: 8,
    name: "Mike Ehrmantraut",
    email: "mikeehrmantraut@gmail.com",
    age: 64,
    phone: "(222)444-5555",
    access: "user",
  },
  {
    id: 9,
    name: "Lydia Rodarte-Quayle",
    email: "lydiarodartequayle@gmail.com",
    age: 35,
    phone: "(444)555-6239",
    access: "admin",
  },
];


export const mockDataContacts = [
  {
    id: 1,
    name: "Walter White",
    email: "walterwhite@gmail.com",
    age: 50,
    phone: "(665)121-5454",
    address: "0912 Won Street, Albuquerque, NM 87101",
    city: "Albuquerque",
    zipCode: "87101",
    registrarId: 123512,
  },
  {
    id: 2,
    name: "Jesse Pinkman",
    email: "jessepinkman@gmail.com",
    age: 25,
    phone: "(421)314-2288",
    address: "1234 Main Street, Albuquerque, NM 87102",
    city: "Albuquerque",
    zipCode: "87102",
    registrarId: 123512,
  },
  {
    id: 3,
    name: "Skyler White",
    email: "skylerwhite@gmail.com",
    age: 45,
    phone: "(422)982-6739",
    address: "3333 Want Blvd, Albuquerque, NM 87103",
    city: "Albuquerque",
    zipCode: "87103",
    registrarId: 4132513,
  },
  {
    id: 4,
    name: "Saul Goodman",
    email: "saulgoodman@gmail.com",
    age: 41,
    phone: "(921)425-6742",
    address: "1514 Main Street, Albuquerque, NM 87104",
    city: "Albuquerque",
    zipCode: "87104",
    registrarId: 123512,
  },
  {
    id: 5,
    name: "Hank Schrader",
    email: "hankschrader@gmail.com",
    age: 43,
    phone: "(421)445-1189",
    address: "11122 Welping Ave, Albuquerque, NM 87105",
    city: "Albuquerque",
    zipCode: "87105",
    registrarId: 123512,
  },
  {
    id: 6,
    name: "Gus Fring",
    email: "gusfring@gmail.com",
    age: 49,
    phone: "(232)545-6483",
    address: "1234 Canvile Street, Albuquerque, NM 87106",
    city: "Albuquerque",
    zipCode: "87106",
    registrarId: 123512,
  },
  {
    id: 7,
    name: "Marie Schrader",
    email: "marieschrader@gmail.com",
    age: 38,
    phone: "(543)124-0123",
    address: "22215 Super Street, Albuquerque, NM 87107",
    city: "Albuquerque",
    zipCode: "87107",
    registrarId: 123512,
  },
  {
    id: 8,
    name: "Mike Ehrmantraut",
    email: "mikeehrmantraut@gmail.com",
    age: 64,
    phone: "(222)444-5555",
    address: "4123 Ever Blvd, Albuquerque, NM 87108",
    city: "Albuquerque",
    zipCode: "87108",
    registrarId: 512315,
  },
  {
    id: 9,
    name: "Lydia Rodarte-Quayle",
    email: "lydiarodartequayle@gmail.com",
    age: 35,
    phone: "(444)555-6239",
    address: "51234 Avery Street, Houston, TX 77001",
    city: "Houston",
    zipCode: "77001",
    registrarId: 928397,
  },
  {
    id: 10,
    name: "Todd Alquist",
    email: "toddaquist@gmail.com",
    age: 29,
    phone: "(222)444-5555",
    address: "4123 Easer Blvd, Houston, TX 77002",
    city: "Houston",
    zipCode: "77002",
    registrarId: 533215,
  },
  {
    id: 11,
    name: "Jane Margolis",
    email: "janemargolis@gmail.com",
    age: 27,
    phone: "(444)555-6239",
    address: "51234 Fiveton Street, Albuquerque, NM 87109",
    city: "Albuquerque",
    zipCode: "87109",
    registrarId: 92197,
  },
];


export const mockDataInvoices = [
  {
    id: 1,
    name: "Walter White",
    email: "walterwhite@gmail.com",
    cost: "21.24",
    phone: "(665)121-5454",
    date: "03/12/2022",
  },
  {
    id: 2,
    name: "Jesse Pinkman",
    email: "jessepinkman@gmail.com",
    cost: "1.24",
    phone: "(421)314-2288",
    date: "06/15/2021",
  },
  {
    id: 3,
    name: "Skyler White",
    email: "skylerwhite@gmail.com",
    cost: "11.24",
    phone: "(422)982-6739",
    date: "05/02/2022",
  },
  {
    id: 4,
    name: "Saul Goodman",
    email: "saulgoodman@gmail.com",
    cost: "80.55",
    phone: "(921)425-6742",
    date: "03/21/2022",
  },
  {
    id: 5,
    name: "Hank Schrader",
    email: "hankschrader@gmail.com",
    cost: "1.24",
    phone: "(421)445-1189",
    date: "01/12/2021",
  },
  {
    id: 6,
    name: "Gus Fring",
    email: "gusfring@gmail.com",
    cost: "63.12",
    phone: "(232)545-6483",
    date: "11/02/2022",
  },
  {
    id: 7,
    name: "Marie Schrader",
    email: "marieschrader@gmail.com",
    cost: "52.42",
    phone: "(543)124-0123",
    date: "02/11/2022",
  },
  {
    id: 8,
    name: "Mike Ehrmantraut",
    email: "mikeehrmantraut@gmail.com",
    cost: "21.24",
    phone: "(222)444-5555",
    date: "05/02/2021",
  },
];


export const mockTransactions = [
  {
    txId: "bb01",
    user: "walterwhite",
    date: "2024-01-15",
    cost: "102.50",
  },
  {
    txId: "bb02",
    user: "jessepinkman",
    date: "2024-02-20",
    cost: "150.75",
  },
  {
    txId: "bb03",
    user: "saulgoodman",
    date: "2024-03-10",
    cost: "58.20",
  },
  {
    txId: "bb04",
    user: "hankschrader",
    date: "2024-04-25",
    cost: "320.00",
  },
  {
    txId: "bb05",
    user: "gustavofringe",
    date: "2024-05-30",
    cost: "75.40",
  },
  {
    txId: "bb06",
    user: "skylerwhite",
    date: "2024-06-15",
    cost: "89.10",
  },
  {
    txId: "bb07",
    user: "mikeehrmantraut",
    date: "2024-07-05",
    cost: "45.00",
  },
  {
    txId: "bb08",
    user: "jessiepinkman",
    date: "2024-08-22",
    cost: "130.60",
  },
];


export const mockBarData = [
  {
    country: "US",
    "electronics": 210,
    "electronicsColor": "hsl(210, 70%, 50%)",
    clothing: 150,
    clothingColor: "hsl(340, 70%, 50%)",
    home: 180,
    homeColor: "hsl(90, 70%, 50%)",
    toys: 120,
    toysColor: "hsl(150, 70%, 50%)",
  },
  {
    country: "UK",
    "electronics": 170,
    "electronicsColor": "hsl(200, 70%, 50%)",
    clothing: 130,
    clothingColor: "hsl(320, 70%, 50%)",
    home: 140,
    homeColor: "hsl(80, 70%, 50%)",
    toys: 90,
    toysColor: "hsl(140, 70%, 50%)",
  },
  {
    country: "CA",
    "electronics": 190,
    "electronicsColor": "hsl(220, 70%, 50%)",
    clothing: 110,
    clothingColor: "hsl(300, 70%, 50%)",
    home: 160,
    homeColor: "hsl(100, 70%, 50%)",
    toys: 130,
    toysColor: "hsl(160, 70%, 50%)",
  },
  {
    country: "AU",
    "electronics": 220,
    "electronicsColor": "hsl(230, 70%, 50%)",
    clothing: 140,
    clothingColor: "hsl(340, 70%, 50%)",
    home: 190,
    homeColor: "hsl(110, 70%, 50%)",
    toys: 110,
    toysColor: "hsl(170, 70%, 50%)",
  },
  {
    country: "DE",
    "electronics": 250,
    "electronicsColor": "hsl(240, 70%, 50%)",
    clothing: 120,
    clothingColor: "hsl(330, 70%, 50%)",
    home: 170,
    homeColor: "hsl(120, 70%, 50%)",
    toys: 140,
    toysColor: "hsl(180, 70%, 50%)",
  },
  {
    country: "FR",
    "electronics": 180,
    "electronicsColor": "hsl(260, 70%, 50%)",
    clothing: 160,
    clothingColor: "hsl(340, 70%, 50%)",
    home: 150,
    homeColor: "hsl(130, 70%, 50%)",
    toys: 100,
    toysColor: "hsl(190, 70%, 50%)",
  },
  {
    country: "JP",
    "electronics": 210,
    "electronicsColor": "hsl(270, 70%, 50%)",
    clothing: 140,
    clothingColor: "hsl(350, 70%, 50%)",
    home: 180,
    homeColor: "hsl(140, 70%, 50%)",
    toys: 120,
    toysColor: "hsl(200, 70%, 50%)",
  },
];


export const mockPieData = [
  {
    id: "javascript",
    label: "javascript",
    value: 300,
    color: "hsl(40, 70%, 50%)",
  },
  {
    id: "python",
    label: "python",
    value: 220,
    color: "hsl(60, 70%, 50%)",
  },
  {
    id: "java",
    label: "java",
    value: 430,
    color: "hsl(120, 70%, 50%)",
  },
  {
    id: "ruby",
    label: "ruby",
    value: 310,
    color: "hsl(240, 70%, 50%)",
  },
  {
    id: "csharp",
    label: "csharp",
    value: 500,
    color: "hsl(300, 70%, 50%)",
  },
];


export const mockLineData = [
  {
    id: "germany",
    color: tokens("dark").greenAccent[500],
    data: [
      {
        x: "plane",
        y: 120,
      },
      {
        x: "helicopter",
        y: 85,
      },
      {
        x: "boat",
        y: 56,
      },
      {
        x: "train",
        y: 196,
      },
      {
        x: "subway",
        y: 45,
      },
      {
        x: "bus",
        y: 226,
      },
      {
        x: "car",
        y: 98,
      },
      {
        x: "moto",
        y: 202,
      },
      {
        x: "bicycle",
        y: 261,
      },
      {
        x: "horse",
        y: 11,
      },
      {
        x: "skateboard",
        y: 55,
      },
      {
        x: "others",
        y: 24,
      },
    ],
  },
  {
    id: "italy",
    color: tokens("dark").blueAccent[300],
    data: [
      {
        x: "plane",
        y: 192,
      },
      {
        x: "helicopter",
        y: 180,
      },
      {
        x: "boat",
        y: 250,
      },
      {
        x: "train",
        y: 19,
      },
      {
        x: "subway",
        y: 95,
      },
      {
        x: "bus",
        y: 165,
      },
      {
        x: "car",
        y: 53,
      },
      {
        x: "moto",
        y: 179,
      },
      {
        x: "bicycle",
        y: 77,
      },
      {
        x: "horse",
        y: 67,
      },
      {
        x: "skateboard",
        y: 289,
      },
      {
        x: "others",
        y: 241,
      },
    ],
  },
  {
    id: "canada",
    color: tokens("dark").redAccent[200],
    data: [
      {
        x: "plane",
        y: 171,
      },
      {
        x: "helicopter",
        y: 126,
      },
      {
        x: "boat",
        y: 81,
      },
      {
        x: "train",
        y: 170,
      },
      {
        x: "subway",
        y: 201,
      },
      {
        x: "bus",
        y: 142,
      },
      {
        x: "car",
        y: 179,
      },
      {
        x: "moto",
        y: 142,
      },
      {
        x: "bicycle",
        y: 18,
      },
      {
        x: "horse",
        y: 177,
      },
      {
        x: "skateboard",
        y: 117,
      },
      {
        x: "others",
        y: 150,
      },
    ],
  },
];


export const mockGeographyData = [
  {
    id: "AFG",
    value: 520600,
  },
  {
    id: "AGO",
    value: 949905,
  },
  {
    id: "ALB",
    value: 329910,
  },
  {
    id: "ARE",
    value: 675484,
  },
  {
    id: "ARG",
    value: 432239,
  },
  {
    id: "ARM",
    value: 288305,
  },
  {
    id: "ATA",
    value: 415648,
  },
  {
    id: "ATF",
    value: 665159,
  },
  {
    id: "AUT",
    value: 798526,
  },
  {
    id: "AZE",
    value: 481678,
  },
  {
    id: "BDI",
    value: 496457,
  },
  {
    id: "BEL",
    value: 252276,
  },
  {
    id: "BEN",
    value: 440315,
  },
  {
    id: "BFA",
    value: 343752,
  },
  {
    id: "BGD",
    value: 920203,
  },
  {
    id: "BGR",
    value: 261196,
  },
  {
    id: "BHS",
    value: 421551,
  },
  {
    id: "BIH",
    value: 974745,
  },
  {
    id: "BLR",
    value: 349288,
  },
  {
    id: "BLZ",
    value: 305983,
  },
  {
    id: "BOL",
    value: 430840,
  },
  {
    id: "BRN",
    value: 345666,
  },
  {
    id: "BTN",
    value: 649678,
  },
  {
    id: "BWA",
    value: 319392,
  },
  {
    id: "CAF",
    value: 722549,
  },
  {
    id: "CAN",
    value: 332843,
  },
  {
    id: "CHE",
    value: 122159,
  },
  {
    id: "CHL",
    value: 811736,
  },
  {
    id: "CHN",
    value: 593604,
  },
  {
    id: "CIV",
    value: 143219,
  },
  {
    id: "CMR",
    value: 630627,
  },
  {
    id: "COG",
    value: 498556,
  },
  {
    id: "COL",
    value: 660527,
  },
  {
    id: "CRI",
    value: 60262,
  },
  {
    id: "CUB",
    value: 177870,
  },
  {
    id: "-99",
    value: 463208,
  },
  {
    id: "CYP",
    value: 945909,
  },
  {
    id: "CZE",
    value: 500109,
  },
  {
    id: "DEU",
    value: 63345,
  },
  {
    id: "DJI",
    value: 634523,
  },
  {
    id: "DNK",
    value: 731068,
  },
  {
    id: "DOM",
    value: 262538,
  },
  {
    id: "DZA",
    value: 760695,
  },
  {
    id: "ECU",
    value: 301263,
  },
  {
    id: "EGY",
    value: 148475,
  },
  {
    id: "ERI",
    value: 939504,
  },
  {
    id: "ESP",
    value: 706050,
  },
  {
    id: "EST",
    value: 977015,
  },
  {
    id: "ETH",
    value: 461734,
  },
  {
    id: "FIN",
    value: 22800,
  },
  {
    id: "FJI",
    value: 18985,
  },
  {
    id: "FLK",
    value: 64986,
  },
  {
    id: "FRA",
    value: 447457,
  },
  {
    id: "GAB",
    value: 669675,
  },
  {
    id: "GBR",
    value: 757120,
  },
  {
    id: "GEO",
    value: 158702,
  },
  {
    id: "GHA",
    value: 893180,
  },
  {
    id: "GIN",
    value: 877288,
  },
  {
    id: "GMB",
    value: 724530,
  },
  {
    id: "GNB",
    value: 387753,
  },
  {
    id: "GNQ",
    value: 706118,
  },
  {
    id: "GRC",
    value: 377796,
  },
  {
    id: "GTM",
    value: 66890,
  },
  {
    id: "GUY",
    value: 719300,
  },
  {
    id: "HND",
    value: 739590,
  },
  {
    id: "HRV",
    value: 929467,
  },
  {
    id: "HTI",
    value: 538961,
  },
  {
    id: "HUN",
    value: 146095,
  },
  {
    id: "IDN",
    value: 490681,
  },
  {
    id: "IND",
    value: 549818,
  },
  {
    id: "IRL",
    value: 630163,
  },
  {
    id: "IRN",
    value: 596921,
  },
  {
    id: "IRQ",
    value: 767023,
  },
  {
    id: "ISL",
    value: 478682,
  },
  {
    id: "ISR",
    value: 963688,
  },
  {
    id: "ITA",
    value: 393089,
  },
  {
    id: "JAM",
    value: 83173,
  },
  {
    id: "JOR",
    value: 52005,
  },
  {
    id: "JPN",
    value: 199174,
  },
  {
    id: "KAZ",
    value: 181424,
  },
  {
    id: "KEN",
    value: 60946,
  },
  {
    id: "KGZ",
    value: 432478,
  },
  {
    id: "KHM",
    value: 254461,
  },
  {
    id: "OSA",
    value: 942447,
  },
  {
    id: "KWT",
    value: 414413,
  },
  {
    id: "LAO",
    value: 448339,
  },
  {
    id: "LBN",
    value: 620090,
  },
  {
    id: "LBR",
    value: 435950,
  },
  {
    id: "LBY",
    value: 75091,
  },
  {
    id: "LKA",
    value: 595124,
  },
  {
    id: "LSO",
    value: 483524,
  },
  {
    id: "LTU",
    value: 867357,
  },
  {
    id: "LUX",
    value: 689172,
  },
  {
    id: "LVA",
    value: 742980,
  },
  {
    id: "MAR",
    value: 236538,
  },
  {
    id: "MDA",
    value: 926836,
  },
  {
    id: "MDG",
    value: 840840,
  },
  {
    id: "MEX",
    value: 353910,
  },
  {
    id: "MKD",
    value: 505842,
  },
  {
    id: "MLI",
    value: 286082,
  },
  {
    id: "MMR",
    value: 915544,
  },
  {
    id: "MNE",
    value: 609500,
  },
  {
    id: "MNG",
    value: 410428,
  },
  {
    id: "MOZ",
    value: 32868,
  },
  {
    id: "MRT",
    value: 375671,
  },
  {
    id: "MWI",
    value: 591935,
  },
  {
    id: "MYS",
    value: 991644,
  },
  {
    id: "NAM",
    value: 701897,
  },
  {
    id: "NCL",
    value: 144098,
  },
  {
    id: "NER",
    value: 312944,
  },
  {
    id: "NGA",
    value: 862877,
  },
  {
    id: "NIC",
    value: 90831,
  },
  {
    id: "NLD",
    value: 281879,
  },
  {
    id: "NOR",
    value: 224537,
  },
  {
    id: "NPL",
    value: 322331,
  },
  {
    id: "NZL",
    value: 86615,
  },
  {
    id: "OMN",
    value: 707881,
  },
  {
    id: "PAK",
    value: 158577,
  },
  {
    id: "PAN",
    value: 738579,
  },
  {
    id: "PER",
    value: 248751,
  },
  {
    id: "PHL",
    value: 557292,
  },
  {
    id: "PNG",
    value: 516874,
  },
  {
    id: "POL",
    value: 682137,
  },
  {
    id: "PRI",
    value: 957399,
  },
  {
    id: "PRT",
    value: 846430,
  },
  {
    id: "PRY",
    value: 720555,
  },
  {
    id: "QAT",
    value: 478726,
  },
  {
    id: "ROU",
    value: 259318,
  },
  {
    id: "RUS",
    value: 268735,
  },
  {
    id: "RWA",
    value: 136781,
  },
  {
    id: "ESH",
    value: 151957,
  },
  {
    id: "SAU",
    value: 111821,
  },
  {
    id: "SDN",
    value: 927112,
  },
  {
    id: "SDS",
    value: 966473,
  },
  {
    id: "SEN",
    value: 158085,
  },
  {
    id: "SLB",
    value: 178389,
  },
  {
    id: "SLE",
    value: 528433,
  },
  {
    id: "SLV",
    value: 353467,
  },
  {
    id: "ABV",
    value: 251,
  },
  {
    id: "SOM",
    value: 445243,
  },
  {
    id: "SRB",
    value: 202402,
  },
  {
    id: "SUR",
    value: 972121,
  },
  {
    id: "SVK",
    value: 319923,
  },
  {
    id: "SVN",
    value: 728766,
  },
  {
    id: "SWZ",
    value: 379669,
  },
  {
    id: "SYR",
    value: 16221,
  },
  {
    id: "TCD",
    value: 101273,
  },
  {
    id: "TGO",
    value: 498411,
  },
  {
    id: "THA",
    value: 506906,
  },
  {
    id: "TJK",
    value: 613093,
  },
  {
    id: "TKM",
    value: 327016,
  },
  {
    id: "TLS",
    value: 607972,
  },
  {
    id: "TTO",
    value: 936365,
  },
  {
    id: "TUN",
    value: 898416,
  },
  {
    id: "TUR",
    value: 237783,
  },
  {
    id: "TWN",
    value: 878213,
  },
  {
    id: "TZA",
    value: 442174,
  },
  {
    id: "UGA",
    value: 720710,
  },
  {
    id: "UKR",
    value: 74172,
  },
  {
    id: "URY",
    value: 753177,
  },
  {
    id: "USA",
    value: 658725,
  },
  {
    id: "UZB",
    value: 550313,
  },
  {
    id: "VEN",
    value: 707492,
  },
  {
    id: "VNM",
    value: 538907,
  },
  {
    id: "VUT",
    value: 650646,
  },
  {
    id: "PSE",
    value: 476078,
  },
  {
    id: "YEM",
    value: 957751,
  },
  {
    id: "ZAF",
    value: 836949,
  },
  {
    id: "ZMB",
    value: 714503,
  },
  {
    id: "ZWE",
    value: 405217,
  },
  {
    id: "KOR",
    value: 171135,
  },
];
